import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {ProcedureType, StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CreateStudyModalOptionalParams} from 'studies/sidepanel/NewStudyDropdown';
import {CLINICAL_STUDIES_VALIDATION_CONSTANTS} from 'studies/StudyConstants';

import {ClinicalStudyState, StudySchema, TypedStudyAdapter} from '../utils/TypedStudyTypes';
import ClinicalStudyDesignTabContents from './ClinicalStudyDesignTabContents';
import ClinicalStudyExecutionOverview from './ClinicalStudyExecutionOverview';
import ClinicalStudyOverviewTabContents from './ClinicalStudyOverviewTabContents';

export const ClinicalStudyAdapter: TypedStudyAdapter<never, ClinicalStudyState> = {
  type: StudyType.CLINICAL,

  procedureType: ProcedureType.ASSAY,

  isMultiProcedureRunEnabled: true,

  isMultiBatchEnabled: false,

  isMultiConditionEnabled: false,

  isNotificationSchedulesEnabled: false,

  isUnitOperationInstanceLinkingEnabled: false,

  isVisualizationEnabled: false,

  isOOTBChartingEnabled: false,

  maxRunsPerStudy: () => CLINICAL_STUDIES_VALIDATION_CONSTANTS.MAX_NUM_ASSAY_RUNS_PER_CLINICAL_BASED_STUDY,

  allowReturnToDesignPhase: true,

  allowRequireDesignApproval: BenchlingConfig.STUDIES_ENABLE_REVIEW,

  renderMetadataSection(_state: ClinicalStudyState) {
    return <></>;
  },

  useTypedStudyState(this: void, studySchema: StudySchema, initialValues: CreateStudyModalOptionalParams) {
    return {experimentParam: null};
  },

  getPerformanceMetadata(state: ClinicalStudyState) {
    return {};
  },

  getAnalyticsMetadata(state: ClinicalStudyState) {
    return {};
  },
  creation: {},
  design: {
    ui: {
      tab: ClinicalStudyDesignTabContents,
    },
  },
  overview: {
    ui: {
      tab: ClinicalStudyOverviewTabContents,
      execution: ClinicalStudyExecutionOverview,
      design: null,
    },
  },
  review: {
    analysis: {
      disallowAdhocAnalysis: true,
    },
  },
};
